ixModuleRouting("impactx.livereport", {
    "/covidstockreport": {
        template: "<ixa-covid-stock-report-list></ixa-covid-stock-report-list>",
        process: "COVIDOrderReport",
        workspace: "monitor",
    },
    "/covidorderreport": {
        template: "<ixa-covid-order-report-list></ixa-covid-order-report-list>",
        process: "COVIDOrderReport",
        workspace: "monitor",
    },
    "/coviduserreport": {
        template: "<ixa-covid-user-report-list></ixa-covid-user-report-list>",
        process: "COVIDUserReport",
        workspace: "monitor",
    },
    "/influenzaorderreport": {
        template: "<ixa-influenza-order-report-list></ixa-influenza-order-report-list>",
        process: "InfluenzaReports",
        workspace: "monitor",
    },
    "/influenzastockreport": {
        template: "<ixa-influenza-stock-report-list></ixa-influenza-stock-report-list>",
        process: "InfluenzaReports",
        workspace: "monitor"
    },
});
